import type { AnalyticsProvider, TrackInput } from "../types";

export const stubAnalyticsProvider: AnalyticsProvider = {
  name: "stub",
  async track(input: TrackInput) {
    if (typeof console !== "undefined") {
      console.info(`[analytics:stub] ${input.event}`, input.properties ?? {});
    return undefined;
    }
  },
  async identify(userId, traits) {
    if (typeof console !== "undefined") {
      console.info(`[analytics:stub] identify ${userId}`, traits ?? {});
    }
  },
};
